import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from '../Logo';
import type { SlideProps } from './SlideShell';
export function Slide01Title({
  index
}: SlideProps) {
  return <div className="relative w-full h-full overflow-hidden bg-white" data-id="element-45" data-mp="103fp303dl05z">
      {/* Hero image with pharmaceutical overlay */}
      <div className="absolute inset-0" data-id="element-46" data-mp="151h7rjww2xgx">
        <motion.img src="https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=1920&q=80" alt="Pharmaceutical capsules" className="w-full h-full object-cover opacity-30 mix-blend-multiply" initial={{
        scale: 1.05
      }} animate={{
        scale: 1
      }} transition={{
        duration: 10,
        ease: 'easeOut'
      }} data-id="element-47" data-mp="154d6hagk9q6f" />
        {/* Molecular structure pattern overlay */}
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} data-id="element-48" data-mp="8ct11jqmiwmt" />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/95 to-white/40" data-id="element-49" data-mp="29fhw35zcs3tm" />
      </div>

      {/* Top brand accent */}
      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      delay: 0.1,
      duration: 0.8,
      ease: 'easeOut'
    }} className="absolute top-0 left-0 right-0 h-2 bg-[var(--brand)] origin-left z-20" data-id="element-50" data-mp="1gtf4vd8nuq39" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center px-[clamp(2rem,6vw,6rem)] pb-[clamp(5rem,9vh,7rem)] pt-[clamp(2rem,4vw,4rem)]" data-id="element-51" data-mp="12znz8fy1vqct">
        <div className="max-w-4xl" data-id="element-52" data-mp="1nrcoacliogac">
          {/* Eyebrow */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.25,
          duration: 0.6
        }} className="flex items-center gap-4 mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-53" data-mp="1noqfyaqsxwr2">
            <span className="h-px w-12 bg-[var(--brand)]" data-id="element-54" data-mp="14ti6b92euuft" />
            <p className="text-[var(--brand)] text-[clamp(0.85rem,1.3vw,1.1rem)] font-bold uppercase tracking-[0.25em]" data-id="element-55" data-mp="18sip4rkw1x2t">
              Proposal
            </p>
          </motion.div>

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.7
        }} className="text-[var(--fg)] font-bold text-[clamp(2.5rem,5.5vw,5rem)] leading-[1.05] tracking-tight mb-[clamp(1.25rem,2.5vw,2rem)]" data-id="element-56" data-mp="1ishyurt1nth9">
            GSK –<br data-id="element-57" data-mp="dmjew0brs9uq" />
            <span className="text-[var(--brand)]" data-id="element-58" data-mp="8t72cokd7tic">Established Brands</span>
            <br data-id="element-59" data-mp="8r40n79uobxs" />
            Snakker Campaign Proposal
          </motion.h1>

          {/* Subline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55,
          duration: 0.6
        }} className="text-[var(--muted)] text-[clamp(1.1rem,1.8vw,1.6rem)] font-medium max-w-3xl leading-snug mb-[clamp(2rem,4vw,3rem)]" data-id="element-60" data-mp="3sj9ryghn4m0">
            Interactive frequent HCP campaigns for the established brand
            portfolio, built from reusable master assets.
          </motion.p>
        </div>
      </div>

      {/* Co-brand footer row */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 0.6
    }} className="absolute bottom-[clamp(1.5rem,3vh,2.5rem)] left-[clamp(2rem,6vw,6rem)] right-[clamp(2rem,6vw,6rem)] z-10 flex items-center justify-between gap-4" data-id="element-61" data-mp="1nb9yhbfwp3v8">
        <div className="flex items-center gap-4" data-id="element-62" data-mp="14j7d5msbkzen">
          <span className="text-[var(--muted)] text-xs font-semibold uppercase tracking-widest hidden sm:inline" data-id="element-63" data-mp="14ifrb3oiyg1k">
            Proposed by
          </span>
          <Logo width={120} data-id="element-64" data-mp="um2xm5szc26t" />
        </div>
        <div className="flex items-center gap-3" data-id="element-65" data-mp="une44ddt7o1m">
          <span className="px-4 py-1.5 bg-[var(--brand)] text-white text-xs font-bold rounded-full uppercase tracking-wider shadow-sm" data-id="element-66" data-mp="zk4jszlpchmi">
            GSK
          </span>
          <span className="px-4 py-1.5 bg-white border border-black/10 text-[var(--fg)] text-xs font-bold rounded-full uppercase tracking-wider shadow-sm" data-id="element-67" data-mp="ln8wq38m8png">
            Established Brands
          </span>
        </div>
      </motion.div>
    </div>;
}